import "../index.css";
import React, { useContext } from "react";

import { CurrentUserContext } from "../contexts/CurrentUserContext";

function Card({
  cards,
  onSelectedCard,
  onEraseCardClick,
  onCardLike,
  onCardLinkClick
}) {
  const currentUser = useContext(CurrentUserContext);

  return (
    <section className="cards">
      {Array.isArray(cards) &&
        cards.map((card, index) => {
          if (!card) return null; //
          const key = card._id || index; // Si la tarjeta no tiene _id, usa el índice del array
          // Verificando si el usuario actual es el propietario de la tarjeta actual
          const isOwn = currentUser && card.owner === currentUser._id;          // Creando una variable que después establecerás en `className` para el botón eliminar
          const cardDeleteButtonClassName = `card__trash ${
            isOwn ? "card__trash_active" : "card__trash"
          }`;

          // Verifica si el usuario actual le dio "like" a la tarjeta
          const isLiked = currentUser && card.likes.some((i) => i === currentUser._id);

          // Crea una variable que después establecerás en `className` para el botón like
          const cardLikeButtonClassName = `card__heart ${
            isLiked ? "card__heart_active" : "card__heart"
          }`;

          return (
            <div className="card" key={key}>
              <img
                className="card__link"
                src={card.link}
                alt={`imagen de ${card.name}`}
                onClick={() => {
                  onSelectedCard(card);
                  onCardLinkClick(card);
                }}
              />
              <button
                className={cardDeleteButtonClassName}
                onClick={() => {
                  onSelectedCard(card);
                  onEraseCardClick();
                }}
              />
              <p className="card__name">{card.name}</p>
              <button
                className={cardLikeButtonClassName}
                onClick={() => onCardLike(card)}
              />
              <p className="card__like-count">
                {card.likes && card.likes.length}
              </p>
            </div>
          );
        })}
    </section>
  );
}

export default Card;
